module.exports = __webpack_public_path__ + "img/unelmakone-karta-sv.d9216ab2.jpg";